<!-- 
<div class="d-flex flex-column h-100">
  <app-modal-header-common
    [dialogRef]="dialogRef"
    title="Budget Map"
  ></app-modal-header-common>

  <div class="d-flex flex-column h-100 p-2">
    <div class="px-3 py-3" *ngIf="data?.isBreadcrumb">
      <ul>
        <li
          *ngFor="
            let breadcrumb of breadCrumbData;
            first as isFirst;
            last as isLast
          "
        >
          <span *ngIf="!isLast" class="color-history-inactive">{{
            breadcrumb
          }}</span>
          <span *ngIf="isLast" class="color-active">{{ breadcrumb }}</span>
        </li>
      </ul>
    </div>

    <div class="flex-1 h-100">
      <mat-tab-group
        (selectedIndexChange)="onTabChange($event)"
        [selectedIndex]="selectedTab"
        class=""
      >
        <mat-tab label="Initiatives" class="mat-tab">
          <div class="tab-content">
            <div *ngIf="loading" class="loading-container">
              <app-loading></app-loading>
            </div>

            <div *ngIf="!loading" class="tree-container">
              <mat-tree
                [dataSource]="dataSource"
                [treeControl]="treeControl"
                class="initiative-tree"
              >
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                  <li class="mat-tree-node" [ngClass]="getNodeClass(node)">
                    <button mat-icon-button disabled></button>
                    <mat-icon class="node-icon">{{
                      getNodeIcon(node)
                    }}</mat-icon>
                    <span class="node-label">{{ node.name }} </span>

                    <div
                      *ngIf="node.type === 'project'"
                      class="project-details"
                    >
                      <app-budget-status-icon
                        [status]="node.data?.financials?.status"
                      ></app-budget-status-icon>
                      <span matTooltip="Total Budget">
                        <img
                          src="./assets/Icons/budget.svg"
                          width="24px"
                          height="24px"
                        />
                        <b>
                          {{
                            node.data?.financials.total_budget
                              | appFormat : "currency"
                          }}
                        </b>
                      </span>
                      <span><b>|</b></span>
                      <span matTooltip="Total Spend">
                        <img
                          src="./assets/Icons/spending.svg"
                          width="24px"
                          height="24px"
                        />
                        <b>
                          {{
                            node.data?.financials?.total_consumed
                              | appFormat : "currency"
                          }}
                        </b>
                      </span>
                    </div>
                  </li>
                </mat-tree-node>

                <mat-nested-tree-node
                  *matTreeNodeDef="let node; when: hasChild"
                  matTreeNodeToggle
                >
                  <li>
                    <div class="mat-tree-node" [ngClass]="getNodeClass(node)">
                      <button
                        mat-icon-button
                        matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name"
                      >
                        <mat-icon class="mat-icon-rtl-mirror">
                          {{
                            treeControl.isExpanded(node)
                              ? "expand_more"
                              : "chevron_right"
                          }}
                        </mat-icon>
                      </button>
                      <mat-icon class="node-icon">{{
                        getNodeIcon(node)
                      }}</mat-icon>
                      <span class="node-label">{{ node.name }}</span>

                      <div *ngIf="node.type === 'initiative'">
                        <app-budget-status-icon
                          [status]="node.data.budget_status"
                          class="me-2"
                        ></app-budget-status-icon>
                        <span class="budget_project" matTooltip="Total Budget">
                          <img
                            src="./assets/Icons/budget.svg"
                            width="24px"
                            height="24px"
                          />
                          <b>
                            {{
                              node.data?.total_budget | appFormat : "currency"
                            }}
                          </b>
                        </span>
                        <span><b>|</b></span>
                        <span matTooltip="Total Spend">
                          <img
                            src="./assets/Icons/spending.svg"
                            width="24px"
                            height="24px"
                          />
                          <b>
                            {{
                              node.data?.total_consumed | appFormat : "currency"
                            }}
                          </b>
                        </span>
                        <span class="project-count"
                          >{{ node.data.total_projects }} project(s)</span
                        >
                      </div>

                      <div *ngIf="node.type === 'tag'" class="tag-details">
                        <app-budget-status-icon
                          [status]="node.data.budget_status"
                          class="me-2"
                        ></app-budget-status-icon>
                        <span class="budget_project" matTooltip="Total Budget">
                          <img
                            src="./assets/Icons/budget.svg"
                            width="24px"
                            height="24px"
                          />
                          <b>
                            {{
                              node.data?.total_budget | appFormat : "currency"
                            }}
                          </b>
                        </span>
                        <span><b>|</b></span>
                        <span matTooltip="Total Spend">
                          <img
                            src="./assets/Icons/spending.svg"
                            width="24px"
                            height="24px"
                          />
                          <b>
                            {{
                              node.data?.total_consumed | appFormat : "currency"
                            }}
                          </b>
                        </span>

                        <span class="project-count"
                          >{{ node.data.total_projects }} project(s)</span
                        >
                      </div>
                    </div>
                    <ul [class.tree-invisible]="!treeControl.isExpanded(node)">
                      <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
                  </li>
                </mat-nested-tree-node>
              </mat-tree>

              <div *ngIf="dataSource.data.length === 0" class="empty-state">
                <p>{{ staticText?.common?.no_data_found }}</p>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Applications">
          <div class="search-legend-container">
            <div class="search-container">
              <mat-form-field
                appearance="outline"
                class="search-field"
                floatLabel="never"
              >
                <input
                  matInput
                  type="text"
                  [(ngModel)]="applicationSearchTerm"
                  (ngModelChange)="onApplicationSearch()"
                  placeholder="Search application name..."
                />
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

          </div>

          <div class="application-tab-content">
            Loading Spinner
            <div *ngIf="loading" class="loading-container">
              <app-loading></app-loading>
            </div>

            <div
              *ngIf="!loading && applicationData"
              class="application-view-container"
            >
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="applicationTableData"
                  class="application-table"
                >
                  <ng-container matColumnDef="project_name">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="project-name-header"
                    >
                      Initiatives
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      class="project-name-cell"
                      [style.background-color]="getRowBackgroundColor(row)"
                    >
                      <div class="project-info">
                        <div class="d-flex gap-2">
                          <span class="project-name">{{
                            row.project_name
                          }}</span>
                          <app-budget-status-icon
                            [status]="row.budget_status"
                          ></app-budget-status-icon>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="budget_spend">
                    <th mat-header-cell *matHeaderCellDef class="budget-header">
                      Budget / Spend
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      class="budget-cell"
                      [style.background-color]="getRowBackgroundColor(row)"
                    >
                      <div class="budget-info">
                        <div class="budget-row">
                          <span class="value">
                            {{
                              shouldShowSymbol(
                                getFormattedValue(row.total_budget)
                              )
                                ? getCurrencySymbol()
                                : ""
                            }}{{
                              getFormattedValue(row.total_budget)
                                | appFormat : "currency"
                            }}
                          </span>

                          /

                          <span class="value">
                            {{
                              shouldShowSymbol(
                                getFormattedValue(row.total_consumed)
                              )
                                ? getCurrencySymbol()
                                : ""
                            }}{{
                              getFormattedValue(row.total_consumed)
                                | appFormat : "currency"
                            }}
                          </span>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container
                    *ngFor="let app of filteredApplications"
                    [matColumnDef]="'app_' + app.id"
                  >
                    <th mat-header-cell *matHeaderCellDef class="app-header">
                      <div class="app-header-content">
                        {{ app.name }}
                      </div>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      class="app-cell"
                      [style.background-color]="getRowBackgroundColor(row)"
                    >
                      <mat-icon
                        *ngIf="row.applications[app.id]"
                        class="check-icon"
                      >
                        check_circle
                      </mat-icon>
                      <span *ngIf="!row.applications[app.id]" class="no-check"
                        >—</span
                      >
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
                <div
                  *ngIf="applicationTableData.data.length === 0"
                  class="empty-state"
                >
                  {{ staticText?.common?.no_data_found }}
                </div>
              </div>


            </div>


            <div
              *ngIf="!loading && !applicationData"
              class="placeholder-content"
            >
              <app-loading></app-loading>
            </div>
          </div>
          <div *ngIf="applicationData" class="tag-legend">
            <div class="legend-items">
              <div *ngFor="let tag of applicationData.tags" class="legend-item">
                <div
                  class="legend-color-box"
                  [style.background-color]="tagColors[tag.id]"
                ></div>
                <span class="legend-label">{{ tag.tag_name }}</span>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>


  <div class="modal-footer">
    <button mat-button color="primary" (click)="onClose()">Close</button>
  </div>
</div> -->

<!-- budget-map.component.html -->
<div class="dialog-wrapper">
  <app-modal-header-common
    [dialogRef]="dialogRef"
    title="Budget Map"
  ></app-modal-header-common>

  <div class="px-3 py-3" *ngIf="data?.isBreadcrumb">
    <ul>
      <li
        *ngFor="
          let breadcrumb of breadCrumbData;
          first as isFirst;
          last as isLast
        "
      >
        <span *ngIf="!isLast" class="color-history-inactive">{{
          breadcrumb
        }}</span>
        <span *ngIf="isLast" class="color-active">{{ breadcrumb }}</span>
      </li>
    </ul>
  </div>
  <div class="dialog-content ms-2 me-2">
    <div class="flex-1 h-100">
      <mat-tab-group
        (selectedIndexChange)="onTabChange($event)"
        [selectedIndex]="selectedTab"
        class=""
      >
        <mat-tab label="Initiatives" class="mat-tab">
          <div class="tab-content">
            <div *ngIf="loading" class="loading-container">
              <app-loading></app-loading>
            </div>

            <!-- Tree Table View -->
            <div
              *ngIf="!loading && visibleNodes?.length"
              class="tree-table-container"
            >
              <table mat-table [dataSource]="visibleNodes" class="tree-table">
                <!-- Name Column -->
                <ng-container matColumnDef="Name">
                  <th mat-header-cell *matHeaderCellDef style="width: 80%">
                    Initiatives
                  </th>
                  <td mat-cell *matCellDef="let node">
                    <div
                      class="name-cell d-flex align-items-center"
                      [style.paddingLeft.px]="node.level * 20"
                    >
                      <!-- Chevron for expandable nodes -->
                      <button
                        *ngIf="node.expandable"
                        mat-icon-button
                        (click)="toggleNode(node); $event.stopPropagation()"
                        class="chevron-btn"
                        type="button"
                      >
                        <mat-icon>
                          {{ node.expanded ? "expand_more" : "chevron_right" }}
                        </mat-icon>
                      </button>

                      <!-- Node Icon -->
                      <mat-icon
                        [ngClass]="getNodeClass(node)"
                        class="node-icon"
                        >{{ getNodeIcon(node) }}</mat-icon
                      >

                      <!-- Node Name -->
                      <span [ngClass]="getNodeClass(node)" class="node-label">{{
                        node.name
                      }}</span>

                      <!-- Project count chip for initiatives and tags -->
                      <span
                        *ngIf="
                          node.type === 'initiative' || node.type === 'tag'
                        "
                        class="project-count-chip"
                      >
                        {{ countProjects(node) }} {{displayLabels?.project | lowercase}}(s)
                      </span>
                    </div>
                  </td>
                </ng-container>

                <!-- Budget Column -->
                <ng-container matColumnDef="Budget">
                  <th mat-header-cell *matHeaderCellDef>Budget</th>
                  <td mat-cell *matCellDef="let node">
                    <app-budget-status-icon
                      *ngIf="
                        node.data?.budget_status || node.type === 'project'
                      "
                      [status]="
                        node.type === 'project'
                          ? node.data?.financials?.status
                          : node.data?.budget_status
                      "
                      style="margin-right: 8px"
                    ></app-budget-status-icon>
                    <img
                      src="./assets/Icons/budget.svg"
                      width="24px"
                      height="24px"
                      style="margin-right: 5px"
                    />
                    <span
                      *ngIf="node.type === 'project'"
                      style="font-weight: 500"
                    >
                      {{
                        node.data?.financials?.total_budget
                          | appFormat : "currency"
                      }}
                    </span>
                    <span
                      *ngIf="node.type !== 'project'"
                      style="font-weight: 500"
                    >
                      {{ node.data?.total_budget | appFormat : "currency" }}
                    </span>
                  </td>
                </ng-container>

                <!-- Spend Column -->
                <ng-container matColumnDef="Spend">
                  <th mat-header-cell *matHeaderCellDef>Spend</th>
                  <td mat-cell *matCellDef="let node">
                    <img
                      src="./assets/Icons/spending.svg"
                      width="24px"
                      height="24px"
                      style="margin-right: 5px"
                    />
                    <span
                      *ngIf="node.type === 'project'"
                      style="font-weight: 500"
                    >
                      {{
                        node.data?.financials?.total_consumed
                          | appFormat : "currency"
                      }}
                    </span>
                    <span
                      *ngIf="node.type !== 'project'"
                      style="font-weight: 500"
                    >
                      {{ node.data?.total_consumed | appFormat : "currency" }}
                    </span>
                  </td>
                </ng-container>

                <!-- Header & Row Definitions -->
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTree"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsTree"
                ></tr>
              </table>
            </div>

            <!-- Empty State -->
            <div
              *ngIf="!loading && visibleNodes?.length === 0"
              class="empty-state"
            >
              <p>{{ staticText?.common?.no_data_found }}</p>
            </div>
          </div>
        </mat-tab>

        <!-- Application View Tab -->
        <mat-tab label="Applications">
          <div class="search-legend-container">
            <div class="search-container">
              <mat-form-field
                appearance="outline"
                class="search-field"
                floatLabel="never"
              >
                <!-- <mat-label>Search Applications</mat-label> -->
                <input
                  matInput
                  type="text"
                  [(ngModel)]="applicationSearchTerm"
                  (ngModelChange)="onApplicationSearch()"
                  placeholder="Search application name..."
                />
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <!-- Tag Legend -->
          </div>

          <div class="application-tab-content">
            <!-- Loading Spinner -->
            <div *ngIf="loading" class="loading-container">
              <app-loading></app-loading>
            </div>

            <!-- Application View Content -->
            <div
              *ngIf="!loading && applicationData"
              class="application-view-container"
            >
              <!-- Application Table -->
              <div class="table-container">
                <table
                  mat-table
                  [dataSource]="applicationTableData"
                  class="application-table"
                >
                  <!-- Project Name Column -->
                  <ng-container matColumnDef="project_name">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="project-name-header"
                    >
                      Initiatives
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      class="project-name-cell"
                      [style.background-color]="getRowBackgroundColor(row)"
                    >
                      <div class="project-info">
                        <div class="d-flex gap-2">
                          <span class="project-name">{{
                            row.project_name
                          }}</span>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Budget/Spend Column -->
                  <ng-container matColumnDef="budget_spend">
                    <th mat-header-cell *matHeaderCellDef class="budget-header">
                      Budget / Spend
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      class="budget-cell"
                      [style.background-color]="getRowBackgroundColor(row)"
                    >
                      <div class="budget-info">
                        <div class="budget-row">
                          <span class="value">
                            <app-budget-status-icon
                              [status]="row.budget_status"
                              style="margin-right: 2px"
                            ></app-budget-status-icon>
                            {{
                              shouldShowSymbol(
                                getFormattedValue(row.total_budget)
                              )
                                ? getCurrencySymbol()
                                : ""
                            }}{{
                              getFormattedValue(row.total_budget)
                                | appFormat : "currency"
                            }}
                          </span>

                          /

                          <span class="value">
                            {{
                              shouldShowSymbol(
                                getFormattedValue(row.total_consumed)
                              )
                                ? getCurrencySymbol()
                                : ""
                            }}{{
                              getFormattedValue(row.total_consumed)
                                | appFormat : "currency"
                            }}
                          </span>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Dynamic Application Columns -->
                  <ng-container
                    *ngFor="let app of filteredApplications"
                    [matColumnDef]="'app_' + app.id"
                  >
                    <th mat-header-cell *matHeaderCellDef class="app-header">
                      <div class="app-header-content">{{ app.name }}</div>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      class="app-cell"
                      [style.background-color]="getRowBackgroundColor(row)"
                    >
                      <mat-icon
                        *ngIf="row.applications[app.id]"
                        class="check-icon"
                      >
                        check_circle
                      </mat-icon>
                      <span *ngIf="!row.applications[app.id]" class="no-check"
                        >—</span
                      >
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>
                </table>
                <div
                  *ngIf="applicationTableData.data.length === 0"
                  class="empty-state"
                >
                  {{ staticText?.common?.no_data_found }}
                </div>
              </div>

              <!-- Empty State -->
            </div>

            <!-- Placeholder when no data -->
            <div
              *ngIf="!loading && !applicationData"
              class="placeholder-content"
            >
              <app-loading></app-loading>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div>
    <div *ngIf="!loading && selectedTab === 0" class="tag-legend mb-2">
      <div
        class="legend-item"
        *ngFor="let type of ['initiative', 'tag', 'project']"
      >
        <div
          class="legend-color-box"
          [style.background-color]="nodeColors[type]"
        ></div>
        <span class="legend-label">{{ type | titlecase }}</span>
      </div>
    </div>
    <div *ngIf="applicationData && selectedTab === 1" class="tag-legend mb-2">
      <div class="legend-items">
        <div *ngFor="let tag of applicationData.tags" class="legend-item">
          <div
            class="legend-color-box"
            [style.background-color]="tagColors[tag.id]"
          ></div>
          <span class="legend-label">{{ tag.tag_name }}</span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <!-- Dialog Actions -->
      <button mat-button color="primary" (click)="onClose()">Close</button>
    </div>
  </div>
</div>
